var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39999 10.3043C5.39999 7.59574 7.59574 5.39999 10.3043 5.39999C13.0129 5.39999 15.2087 7.59574 15.2087 10.3043C15.2087 11.6279 14.6843 12.829 13.8321 13.7113C13.8107 13.7299 13.7899 13.7493 13.7696 13.7696C13.7493 13.7899 13.7299 13.8107 13.7113 13.8321C12.829 14.6843 11.6279 15.2087 10.3043 15.2087C7.59574 15.2087 5.39999 13.0129 5.39999 10.3043ZM14.551 16.248C13.3543 17.1045 11.8882 17.6087 10.3043 17.6087C6.27026 17.6087 3 14.3384 3 10.3043C3 6.27026 6.27026 3 10.3043 3C14.3384 3 17.6087 6.27026 17.6087 10.3043C17.6087 11.8882 17.1045 13.3543 16.248 14.551L20.6485 18.9515C21.1172 19.4201 21.1172 20.1799 20.6485 20.6485C20.1799 21.1172 19.4201 21.1172 18.9515 20.6485L14.551 16.248Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSearch);
export default __webpack_public_path__ + "static/media/line-search.55b8692f948bbf78022a2e438d62a685.svg";
export { ForwardRef as ReactComponent };